import * as yup from "yup";
import { errorMsg } from "../utils/toastMessage";
import { logout } from "../redux/auth/slice";
import { getStore } from "../redux/store";

export async function handleApiRequest(
  method,
  request = "",
  showErrorToast = true,
  onError = () => {}
) {
  const store = getStore();
  if (!store) {
    console.log("Store not found");
    return {};
  }

  try {
    const response = await store.dispatch(method(request)).unwrap();
    // console.log("response", response);

    if (response?.status) {
      return response;
    } else {
      onError(response);
      showErrorToast && errorMsg(JSON.stringify(response.message));
      return {};
    }
  } catch (error) {
    // console.log("error", error);
    onError(error?.data || error);
    if (error?.data?.statusCode === 401) {
      store.dispatch(logout());
    }
    if (showErrorToast) {
      if (error instanceof yup.ValidationError) {
        errorMsg(error?.errors);
      } else {
        errorMsg(error?.message);
      }
    }
    return {};
  }
}
